<template>
  <TransitionSlide :duration="animationDuration">
    <div
      ref="modal"
      class="modal fade"
      @click.self="closeModal"
      :class="[
        { 'show d-block': show },
        { 'd-none': !show },
        { 'modal-mini': type === 'mini' },
        classes
      ]"
      v-show="show"
      tabindex="-1"
      role="dialog"
      :inert="!show"
    >
      <div
        class="modal-dialog"
        role="document"
        :style="modalDialogStyle"
        :class="[
          { 'modal-notice': type === 'notice' },
          { 'modal-dialog-centered': centered },
          modalClasses
        ]"
      >
        <div
          class="modal-content"
          :class="[
            gradient ? `bg-gradient-${gradient}` : '',
            modalContentClasses
          ]"
          :style="modalContentStyle"
        >
          <div v-if="$slots.title" class="modal-title-area">
            <slot name="title"></slot>
          </div>
          <div class="modal-content-row">
          <div class="modal-aside" v-if="$slots.aside">
            <slot name="aside"></slot>
          </div>
          <div class="w-100">
            <div
              class="modal-header"
              :class="[headerClasses]"
              v-if="$slots.header"
            >
              <slot name="header"></slot>
              <slot name="close-button">
                <button
                  type="button"
                  class="btn-close"
                  v-if="showClose"
                  @click="closeModal"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i class="tim-icons icon-simple-remove"></i>
                </button>
              </slot>
            </div>

            <div v-if="$slots.default" class="modal-body" :class="bodyClasses">
              <slot></slot>
            </div>
            <div class="modal-footer p-3" :class="footerClasses" v-if="$slots.footer">
              <slot name="footer"></slot>
            </div>
          </div>
          </div>
        </div>
      </div>
    </div>
  </TransitionSlide>
</template>
<script>
import {TransitionSlide} from "@morev/vue-transitions/vue3";

export default {
  components: {
    TransitionSlide
  },
  props: {
    show: Boolean,
    showClose: {
      type: Boolean,
      default: true
    },
    centered: {
      type: Boolean,
      default: false
    },
    appendToBody: {
      type: Boolean,
      default: true,
      description: 'Whether modal should be appended to document body'
    },
    scrollToBottom: {
      type: Boolean,
      default: true,
      description: "Whether modal should scroll to it's bottom automatically"
    },
    type: {
      type: String,
      default: '',
      validator(value) {
        let acceptedValues = ['', 'notice', 'mini'];
        return acceptedValues.indexOf(value) !== -1;
      },
      description: 'Modal type (notice|mini|"") '
    },
    classes: {
      type: [Object, String],
      description: 'Modal dialog container CSS classes'
    },
    modalClasses: {
      type: [Object, String],
      description: 'Modal dialog CSS classes'
    },
    modalDialogStyle: {
      type: [Object, String],
      description: 'Modal dialog CSS style'
    },
    modalContentStyle: {
      type: [Object, String],
      description: 'Modal dialog content CSS style'
    },
    modalContentClasses: {
      type: [Object, String],
      description: 'Modal dialog content CSS classes'
    },
    gradient: {
      type: String,
      description: 'Modal gradient type (danger, primary etc)'
    },
    headerClasses: {
      type: [Object, String],
      description: 'Modal Header CSS classes'
    },
    bodyClasses: {
      type: [Object, String],
      description: 'Modal Body CSS classes'
    },
    footerClasses: {
      type: [Object, String],
      description: 'Modal Footer CSS classes'
    },
    animationDuration: {
      type: Number,
      default: 500,
      description: 'Modal transition duration'
    }
  },
  methods: {
    closeModal() {
      this.$emit('update:show', false);
      this.$emit('close');
    },
    scrollModalToBottom() {
      if (!this.scrollToBottom) return;
      let elm = this.$refs.modal;
      elm.scrollTop = elm.scrollHeight - elm.clientHeight;
    }
  },
  mounted() {
    if (this.appendToBody) {
      document.body.appendChild(this.$el);
    }
  },
  destroyed() {
    if (this.appendToBody && this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
  },
  watch: {
    show(val) {
      let documentClasses = document.body.classList;
      if (val) {
        documentClasses.add('modal-open');
        this.$nextTick(this.scrollModalToBottom);
      } else {
        documentClasses.remove('modal-open');
      }
    }
  }
};
</script>
<style>
.modal-content {
  display: flex;
  flex-direction: column;
}
.modal-content-row {
  display: flex;
  flex-direction: row;
  flex: 1;
}
.modal-aside {
  max-width: 25%;
  width: 25%;
}
.modal.show {
  background-color: rgba(0, 0, 0, 0.75);
  overflow-y: auto;
  z-index: 2000;
}
</style>
